module.exports = __webpack_public_path__ + "img/checked.74a9e197.png";